<div class="po-row">
  <div id="projectToolBar" class="po-xl-12 po-lg-12 po-md-12 po-sm-12 cp-np">
    <span class="cp-text" style="padding-right: 13px;">{{ literalsCp?.strProjetoAtual + ':' }}</span>
    <span class="cp-container cp-text">{{ contextApplication.Project.description }}
      <span class="cp-rev" style="margin-left: 8px;">REV:{{ contextApplication.Project.review }}</span></span>
  </div>
  <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 cp-np" style="margin-top: 10px;">
    <span class="cp-textdate cp-font-normal" style="padding: 0px;">{{ literalsCp?.strUltimaImportacaoBackOffice + ':' }}
    </span>
    <span class="cp-textdate cp-font-bold"
      style="padding: 0px;">{{ contextApplication.Project.getFormattedDate(contextApplication.Project.lastBackofficeImport, 'A') }}</span>
    <span class="cp-textdate cp-font-normal" style="padding-right: 5px; padding-left: 5px;">|</span>
    <span class="cp-textdate cp-font-normal" style="padding: 0px;">{{ literalsCp?.strUltimoCalculoProjeto + ':' }} </span>
    <span class="cp-textdate cp-font-bold"
      style="padding: 0px;">{{ contextApplication.Project.getFormattedDate(contextApplication.Project.lastCalculation, 'C') }}</span>
  </div>
</div>
